import { Button } from "../../../../components/buttons/button";
import { PopoverMenu } from "../../../../components/dropdown/popover";
import { CaretDown } from "../../../../components/icon/downcaret";
import { FindEventsFilterModal } from "../../../../components/modal/app_modals/findEventsFilterModal";
import { useModalControl } from "../../../../customeHooks/useModalControl";
import { useWindowDimensions } from "../../../../customeHooks/useWindowDimensions";
import {
  AvailableCountries,
  FindEventsQuery,
} from "../../../../redux/features/event/event.types";

export const LocationFilter = ({
  query,
  setQuery,
}: {
  query: FindEventsQuery;
  setQuery: (q: FindEventsQuery) => void;
}) => {
  const { handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl();

  const { width } = useWindowDimensions();

  const locationFilters: {
    name: string;
    value: AvailableCountries | undefined;
    onClick: () => void;
  }[] = [
    {
      name: "All locations",
      value: undefined,
      onClick: () => {
        setQuery({
          ...query,
          category: undefined,
          page: 1,
          country: undefined,
          price: undefined,
        });
      },
    },
    {
      name: `Nigeria`,
      value: "Nigeria",
      onClick: () => {
        setQuery({
          ...query,
          category: undefined,
          page: 1,
          country: "Nigeria",
          price: undefined,
        });
      },
    },
    {
      name: `Canada`,
      value: "Canada",
      onClick: () => {
        setQuery({
          ...query,
          category: undefined,
          page: 1,
          country: "Canada",
          price: undefined,
        });
      },
    },
  ];

  return (
    <>
      <PopoverMenu
        menuItems={locationFilters}
        menuClassName="!min-w-[177px] !rounded-xl !hidden md:!flex"
        menuItemsClassName="!text-grey-950 !font-bold"
        position="bottom start"
        closeOnClick
        className="min-w-max"
      >
        {({ open }) => (
          <Button
            type="button"
            text={
              !!query.country
                ? locationFilters.find((item) => item.value === query.country)
                    ?.name!
                : `Location`
            }
            variation="bland"
            size="zero"
            className={`!w-fit !justify-start gap-[2px] font-onest !text-sm !font-medium !text-ink tracking-[-0.42px] ${open ? "opacity-70" : ""}`}
            extra={<CaretDown width={20} height={20} />}
            onClick={
              width < 768
                ? () => {
                    handleModalOpen("locationFilterModal");
                  }
                : undefined
            }
          />
        )}
      </PopoverMenu>

      <FindEventsFilterModal
        open={modalOpen && modal === "locationFilterModal"}
        handleClose={() => {
          handleModalClose();
        }}
        title="Filter by location"
      >
        <div className="flex flex-col">
          {locationFilters.map((item, idx) => {
            return (
              <button
                type="button"
                className="w-full border-b border-b-grey-100 py-4 text-left text-sm font-bold last:border-b-0"
                onClick={() => {
                  item.onClick();
                  handleModalClose();
                }}
                key={`filter-${idx}-${item.value}`}
              >
                {item.name}
              </button>
            );
          })}
        </div>
      </FindEventsFilterModal>
    </>
  );
};
